import Blue from "../core";

new Blue({
    name: 'Data Dive Sidebar Resizing',
    selector: ".page--data-dive .page-sidebar",
    setup(container) {
			const elNew = (tag, prop = {}) => Object.assign(document.createElement(tag), prop);
			const sidebar = container.querySelector('.page-sidebar__sidebar');
			const main = container.querySelector('.content');
			let sidebarMin = sidebar.style.minWidth;
			let sidebarMax = sidebar.style.maxWidth;
			
			const convertAnyWidthValueToPx = widthString => {
				if (widthString.includes('%')) {
					let containerWidth = container.getBoundingClientRect().width;
					return parseInt(widthString) / 100 * containerWidth;
				} else if (widthString.includes('vw')) {
					return parseInt(widthString) / 100 * window.innerWidth;
				} else if (widthString.includes('rem')) {
					return parseInt(widthString) * parseFloat(getComputedStyle(document.documentElement).fontSize);
				} else if (widthString.includes('em')) {
					return parseInt(widthString) * parseFloat(getComputedStyle(document.documentElement).fontSize);
				} else {
					return parseInt(widthString);
				}
			}
			
			sidebarMin = convertAnyWidthValueToPx(sidebarMin);
			sidebarMax = convertAnyWidthValueToPx(sidebarMax);

			let isResizing = false;

			const resizableGrid = () => {
				const elsPanes = [...container.querySelectorAll(".page-sidebar__sidebar, .content")];
			
				let elPaneCurr = null;
				let paneIndex = -1;

				const setTemplateWidths = (sidebarWidth, parentSize) => {
					container.style["grid-template-columns"] = `${sidebarWidth}px ${parentSize - sidebarWidth}px`;
					main.style.width = `${parentSize - sidebarWidth}px`;
				}
			
				const pointerDown = (evt) => {
					if (isResizing || !evt.target.closest(".gutter")) return;
					isResizing = true;
					elPaneCurr = evt.currentTarget;
					paneIndex = elsPanes.indexOf(elPaneCurr);
					addEventListener("pointermove", pointerMove);
					addEventListener("pointerup", pointerUp);
				};
			
				const pointerMove = (evt) => {
					evt.preventDefault();
					const paneBCR = elPaneCurr.getBoundingClientRect();
					const parentSize = container.getBoundingClientRect().width;
					let pointerX = Math.max(0, Math.min(evt.clientX - paneBCR.left, container.clientWidth));
					main.style.width = "";
					if (pointerX < sidebarMin) {
						pointerX = sidebarMin;
					} else if (pointerX > sidebarMax) {
						pointerX = sidebarMax;
					}
					main.style.width = `${parentSize - pointerX}px`;
					
					setTemplateWidths(pointerX, parentSize);
				};
			
				const pointerUp = (evt) => {
					removeEventListener("pointermove", pointerMove);
					removeEventListener("pointerup", pointerUp);
					isResizing = false;
				};
			
				elsPanes.slice(0, -1).forEach((elPane, i) => {
					elPane.append(elNew("div", {
						className: "gutter"
					}));
					elPane.addEventListener("pointerdown", pointerDown);
				});
				
				window.addEventListener("resize", () => {
					if (window.innerWidth > 768) {
						setTemplateWidths(sidebar.getBoundingClientRect().width, container.getBoundingClientRect().width);
					} else {
						container.style["grid-template-columns"] = "";
						main.style.width = "";
					}
				});
			};

			resizableGrid();
    }
});